import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/hydiene-system/hydiene.css";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import PageStarter from "../../components/hygiene-system/hygiene-common/PageStarter";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import NewTaskLists from "../../components/hygiene-system/taks/NewTaskLists";
import { fetchHygieneTasksData } from "../../redux/hygiene-reducers/hygieneSlice";
import TaskForm from "../../components/hygiene-system/taks/TaskForm";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";

const AllTasks = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedHygineCategory: "",
    selectedTaskPriority: "",
    selTaskInterval: "",
    selMediaType: "",
    selAssignee: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: pageLimit || 10,
    page: isPage + 1,
    category: allFilters.selectedHygineCategory?.value || "",
    priority: allFilters.selectedTaskPriority?.value || "",
    frequency_type: allFilters.selTaskInterval?.value || "",
    media_type: allFilters.selMediaType?.value || "",
    stakeholders: allFilters.selAssignee?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModalvalues = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygieneTasksData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTasks(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit || 10,
      page: isPage + 1,
    }));
  }, [pageLimit, isPage]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      category: allFilters.selectedHygineCategory?.value || "",
      priority: allFilters.selectedTaskPriority?.value || "",
      frequency_type: allFilters.selTaskInterval?.value || "",
      media_type: allFilters.selMediaType?.value || "",
      stakeholders: allFilters.selAssignee?.value || "",
      status: allFilters.isActive?.value || "",
    }));

    setIsPage(0);
  }, [
    allFilters.selectedHygineCategory,
    allFilters.selectedTaskPriority,
    allFilters.selTaskInterval,
    allFilters.selMediaType,
    allFilters.selAssignee,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: daily operation checklist tasks">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModalvalues}
          contentLabel="Hygiene Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName === "add" || modValues.cardName === "edit"
                ? "midWidthModal"
                : modValues.cardName === "task_description"
                ? "mod-width-50p"
                : ""
            }`}
          >
            {modValues.cardName === "task_description" && (
              <ModalHeadAndClose
                title={`${modValues.cardName?.replace(/_/g, " ")}`}
                onClose={onCloseModalvalues}
              />
            )}

            {modValues.cardName === "add" || modValues.cardName === "edit" ? (
              <TaskForm
                userInfoData={userInfoData}
                callFunction={() => getHygieneTasks(filters)}
                closeModal={onCloseModalvalues}
                isEdit={modValues.cardName === "edit"}
                rowData={modValues.rowData}
              />
            ) : modValues.cardName === "task_description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description || "No Content Available"}
                </p>
              </div>
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <PageStarter
              pageName={"checklist tasks"}
              btnLabel={"+ Add Task"}
              searchPlaceHolder={"task"}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickAdd={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }));
              }}
              isReload={() => getHygieneTasks(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"hygiene-taks"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <NewTaskLists
              userInfoData={userInfoData}
              setModValues={setModValues}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={() => getHygieneTasks(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default AllTasks;
